import React from 'react';
import CreditBadge from '../common/CreditBadge';

const ResultsStep = ({ onNavigate, onDataUpdate, result, type, targetRole, originalScore, uploadedFile, reviewedData }) => {
  if (!result) {
    return (
      <div className="bg-slate-50 flex flex-col items-center justify-center p-8 text-center min-h-screen">
        <div className="bg-white border border-slate-200 rounded-3xl p-12 max-w-md">
          <span className="msi text-slate-300 text-[64px] mb-4">description</span>
          <p className="text-slate-600 mb-8 font-inter">No results to display. Please start from the beginning.</p>
          <button className="h-[52px] px-8 bg-blue-500 text-white font-bold rounded-xl w-full" onClick={() => onNavigate('dashboard')}>Back to Dashboard</button>
        </div>
      </div>
    );
  }

  const handleDownload = () => {
    const a = document.createElement('a');
    a.href = result.downloadUrl;
    a.target = '_blank';
    a.download = result.fileName || 'resume.pdf';
    a.click();
  };

  return (
    <div className="bg-slate-50 text-slate-800 font-inter flex flex-col min-h-screen">
      <nav className="bg-white border-b border-slate-200 sticky top-0 z-[100]">
        <div className="max-w-[1200px] mx-auto px-8 h-[68px] flex items-center justify-between">
          <div className="flex items-center gap-[10px] cursor-pointer" onClick={() => onNavigate('dashboard')}>
            <div className="w-[38px] h-[38px] bg-navy rounded-[10px] flex items-center justify-center"><span className="msi text-white">article</span></div>
            <span className="font-montserrat font-extrabold text-xl text-navy">Accredian AI</span>
          </div>
          <CreditBadge />
        </div>
      </nav>

      <div className="max-w-[900px] mx-auto px-8 py-10 w-full flex-1">
        <div className="text-center mb-10 animate-fade-up">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-premium-green-light rounded-2xl mb-6"><span className="msi text-premium-green text-[48px]">check_circle</span></div>
          <h1 className="text-[36px] font-extrabold text-navy font-montserrat">{type === 'create' ? 'Career Transition Resume Created!' : 'Resume Enhanced!'}</h1>
          <p className="text-[18px] text-slate-500">Your professional resume is ready for download</p>
        </div>

        <div className="bg-white border border-slate-200 rounded-3xl p-8 shadow-sm mb-7 bg-gradient-to-br from-indigo-50/50 to-purple-50/50 animate-fade-up">
          <h2 className="text-[20px] font-bold text-navy font-montserrat flex items-center justify-center gap-2 mb-8">
            {type === 'create' ? <span className="msi text-blue">target</span> : <span className="msi text-blue">trending_up</span>}
            {type === 'create' ? 'Career Transition Summary' : 'Enhancement Summary'}
          </h2>

          {type === 'create' && result.metadata && (
            <div className="grid md:grid-cols-2 gap-4 mb-8">
              <div className="bg-white p-5 rounded-2xl border border-slate-200 font-montserrat">
                <p className="text-[11px] font-extrabold text-slate-400 uppercase tracking-widest mb-1.5">From</p>
                <p className="text-[17px] font-bold text-navy truncate">{result.metadata.originalRole || 'Current Role'}</p>
              </div>
              <div className="bg-white p-5 rounded-2xl border-blue-200 border-l-[4px] border-l-blue font-montserrat">
                <p className="text-[11px] font-extrabold text-blue uppercase tracking-widest mb-1.5">To</p>
                <p className="text-[17px] font-bold text-blue truncate">{result.metadata.targetRole || targetRole || 'Target Role'}</p>
              </div>
            </div>
          )}

          {type === 'enhance' && (
            <div className="flex justify-center items-center gap-10 p-8 bg-white border border-slate-200 rounded-3xl shadow-sm mb-8">
              <div className="text-center">
                <p className="text-[11px] font-extrabold text-slate-400 uppercase tracking-widest mb-2 font-montserrat">Original</p>
                <div className="text-[36px] font-extrabold text-slate-400 font-montserrat">{originalScore || 'N/A'}</div>
              </div>
              <div className="flex flex-col items-center"><span className="msi text-premium-green text-[28px] animate-bounce">trending_up</span></div>
              <div className="text-center">
                <p className="text-[11px] font-extrabold text-blue uppercase tracking-widest mb-2 font-montserrat">Optimized</p>
                <div className="text-[42px] font-black text-blue font-montserrat">{result.atsScore || result.matchScore || '--'}</div>
              </div>
            </div>
          )}
        </div>

        <div className="bg-white border border-slate-200 rounded-3xl p-8 shadow-sm mb-7 animate-fade-up">
          <div className="grid md:grid-cols-2 gap-4">
            <button onClick={handleDownload} className="h-14 bg-blue-500 text-white font-bold rounded-xl flex items-center justify-center gap-2">
              <span className="msi">picture_as_pdf</span> Download Resume (PDF)
            </button>
            <button className="h-14 border border-slate-200 text-navy font-bold rounded-xl flex items-center justify-center gap-2" onClick={() => onNavigate('review', { uploadedFile, existingData: reviewedData || result?.resumeData })}>
              <span className="msi">edit_document</span> Edit & Regenerate
            </button>
          </div>
        </div>

        <button className="w-full flex items-center justify-center gap-2 text-slate-400 font-bold hover:text-navy transition-all py-10 uppercase tracking-wider" onClick={() => onNavigate('dashboard')}>
          <span className="msi text-[18px]">home</span> Back to Dashboard
        </button>
      </div>
    </div>
  );
};

export default ResultsStep;
